import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';

function SmsInfoBlurb({ hasAdvancedAlerting }) {
  if (hasAdvancedAlerting) {
    return (
      <div className="alert alert-info rounded my-1">
        {'Any administrator or Operator-level user on this account has access to configure SMS alert notifications. Each time an SMS notification is sent, the price of the message is deducted from your '}
        <i>Balance-to-date</i>
        .
      </div>
    );
  }

  return (
    <div className="alert alert-info rounded my-1">
      <b>
        <Icon icon="info-circle" />
        {' '}
        Upgrade to Enable Support for SMS Notifications
      </b>
      <br />
      {'Any administrator or Operator-level user on this account has access to configure SMS alert notifications. Each time an SMS notification is sent, the price of the message is deducted from your '}
      <i>Balance-to-date</i>
      .
    </div>
  );
}

SmsInfoBlurb.propTypes = {
  hasAdvancedAlerting: PropTypes.bool.isRequired,
};

export default SmsInfoBlurb;
